import { fetchPost } from "~/utils/fetch";
import { Routes, toApiPath } from "../dto/version.gen";

type TOutputDto = Routes.PostCommonUserControllerHandle.ResponseBody;

/** 유저 정보 조회 */
export const postCommonUser = () =>
  fetchPost<TOutputDto>({
    url: toApiPath("/common-user"),
  });
